module.exports = __webpack_public_path__ + "static/media/feup.95885bec.jpg";